import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/master/fee-rate-exclude-countries'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions
    },
    mutations: {
        ...base.mutations
    },
}
